import {createApp} from 'vue'

// import VUE components
import Example from './components/example.vue';

(function ($) {
    
    var $=require('jquery');
    window.jQuery = window.$ = $;
    //require('bootstrap');
    require("./scss/main.scss");
    require('datatables.net');
    require('datatables.net-dt');
    require('leaflet');
    require('corejs-typeahead');
    require('typeahead-address-photon');

    let render_component = function (component, id, data) {
        createApp(component,data).mount(id);
    }

    ///// VUE DEFAULT SHORTCODES START

    ///// ##0 EXAMPLE
    window.render_example = function (id, dataValue) {
        return render_component(Example, id, dataValue);
    }
    ///// VUE DEFAULT SHORTCODES END


})(window.jQuery); 